import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true, // process.env.NODE_ENV !== 'production',
  state: {
    project: {},
    language: 'cn',
    i18n: {},
    changeLog: null,
    baseImgUrl: '',
    site: '',
    isDemo: false,
    isChangeLog: false
  },
  mutations: {
    baseImgUrl: (state, url) => {
      state.baseImgUrl = url
    },
    changeLog: (state, val) => {
      state.changeLog = val
    },
    site: (state, val) => {
      state.site = val
    },
    language: (state, val) => {
      state.language = val
    },
    project: (state, val) => {
      state.project = val
    },
    changeLanguage (state, val) {
      state.language = val
      this.commit('loadLanguage')
    },
    loadLanguage: state => {
      if (state.language) {
        state.i18n = require(`@/i18n/${state.language}`)
      }
    },
    isDemo: (state, val) => {
      state.isDemo = val
    },
    isChangeLog: (state, val) => {
      state.isChangeLog = val
    }
  }
})
